export default {
  "home.heading.default": "サクッと話そう",
  "home.heading.loading": "ルーム準備中...",
  "home.heading.join": "参加する？",
  "home.heading.joined": "入室完了！",
  "home.heading.pending": "ホスト待ち...",
  "home.body.default": "ルームを作ってリンクをシェア。あとは楽しむだけ。",
  "home.body.loading": "ちょっと待ってね、ルームを準備してるよ。",
  "home.body.join": "カメラとマイクを確認して、飛び込もう。",
  "home.body.joined": "ルーム公開中。リンクをシェアして始めよう。",
  "home.body.joined_in_room": "ルームにいるよ。参加するかリンクをシェアしてね。",
  "home.body.pending": "ルームはロックされてるよ。ホストが入れてくれるまで待ってね。",
  "home.cta.create": "ルームを作る",
  "home.cta.join": "ルームに入る",
  "home.cta.enter": "入室する",
  "home.cta.creating": "作成中...",
  "home.cta.joining": "参加中...",
  "home.cta.opening": "準備中...",
  "home.cta.pending": "承認待ち...",
  "home.copy_link": "リンクをコピー",
  "home.copied": "コピーしたよ！",
  "home.leave": "退出する",
  "home.back": "戻る",
  "home.no_participants": "まだ誰もいないよ",
  "home.join_by_code": "招待コードで参加",
  "home.code_placeholder": "コードを入力",
  "home.name_placeholder": "名前",
  "home.people_one": "人",
  "home.people_other": "人",
  "home.marketing.invite.title": "ルームを作って、\nリンクをシェア。",
  "home.marketing.invite.body": "ワンタップで開始。友達にリンクを送るだけで誰でも参加できるよ。ダウンロードも登録も不要。",
  "home.marketing.invite.preview_url": "yano.ai/ROOM",
  "home.marketing.look.title": "自分らしい\nスタイルで。",
  "home.marketing.look.body": "カラー調整、ソフトフォーカス、ビネット、顔ぼかしもOK。カメラも見た目も自分好みに。",
  "home.marketing.host.title": "自分のスペース、\n自分のルール。",
  "home.marketing.host.body": "ルームのロック、ミュート、退出も自由自在。ホストがすべてコントロールできるよ。",
  "home.marketing.host.locked": "ルームロック中",
  "home.marketing.host.waiting_to_join": "参加待ち",
  "home.marketing.host.wants_to_join": "が参加したがってるよ",
  "home.marketing.anything.title": "ぶっちゃけ、何にでも使える。",
  "home.marketing.anything.body": "勉強会、ゲーム、仕事のMTG、同時視聴、ただの雑談にも。",
  "home.marketing.use_case.study_group": "📚 勉強会",
  "home.marketing.use_case.game_night": "🎮 ゲーム",
  "home.marketing.use_case.standup": "💼 MTG",
  "home.marketing.use_case.watch_party": "🍿 同時視聴",
  "home.marketing.use_case.catch_up": "☕ 雑談",
  "home.marketing.use_case.jam_session": "🎸 セッション",
  "home.marketing.use_case.book_club": "📖 読書会",
  "home.marketing.use_case.coworking": "💻 もくもく会",
  "ended.heading": "通話終了",
  "ended.left": "ルームを退出したよ。",
  "ended.room_ended": "{title} は終了したよ。",
  "ended.rejoin": "再参加",
  "ended.rejoining": "再参加中...",
  "ended.home": "ホームに戻る",
  "call.connecting": "接続中",
  "call.waiting": "他の人を待ってるよ",
  "call.invite_code": "招待コード",
  "call.audio_on": "音声オン",
  "call.muted": "ミュート中",
  "call.listening": "聞いてるよ",
  "call.audio_muted": "音声ミュート中",
  "call.speaking": "話してるよ",
  "call.you": "自分",
  "call.you_label": "自分",
  "call.you_suffix": "(自分)",
  "call.chat_placeholder": "メッセージを送信...",
  "call.guest": "ゲスト",
  "call.room_fallback": "ルーム",
  "call.focus_view": "フォーカスビュー",
  "call.grid_view": "グリッドビュー",
  "call.swap_main_video": "メインビデオを切り替え",
  "call.open_chat": "チャットを開く",
  "call.close_chat": "チャットを閉じる",
  "call.leave_room": "退出する",
  "call.confirm_leave": "退出する？",
  "call.mic_on": "マイクオン",
  "call.muted_label": "ミュート中",
  "call.camera_off": "カメラオフ",
  "call.connect_failed": "接続失敗 — ネット環境を確認してやり直してね。",
  "call.camera_access_failed": "カメラにアクセスできないよ。ブラウザの権限をチェックしてみて。",
  "call.recording_failed": "録画を開始できなかったよ。このまま通話を続けるね。",
  "call.initialize_failed": "通話の開始でエラーが起きたみたい。リロードしてやり直してね。",
  "call.participants": "参加者",
  "call.open_participants": "参加者を開く",
  "call.close_participants": "参加者を閉じる",
  "call.lock_room": "ルームをロック",
  "call.unlock_room": "ルームのロックを解除",
  "call.locked": "ロック中",
  "call.unlocked": "オープン",
  "call.kick_member": "ルームから退出させる",
  "call.mute_member": "ミュートする",
  "call.unmute_member": "ミュート解除",
  "call.muted_by_host": "ホストがミュートしたよ",
  "call.waiting_to_join": "参加待ち",
  "call.approve": "承認",
  "call.deny": "拒否",
  "call.profile_actions": "プロフィール操作",
  "call.profile_in_room": "入室中",
  "call.profile_role_host": "ホスト",
  "call.profile_role_you": "自分",
  "call.profile_action_mute": "音声をミュート",
  "call.profile_action_mute_meta": "自分だけミュート（相手にはバレないよ）",
  "call.profile_action_dm": "1:1 DM",
  "call.profile_action_dm_meta": "こっそり個別チャットする",
  "call.profile_action_view": "プロフィールを見る",
  "call.profile_action_view_meta": "自己紹介、言語、過去のセッションなど",
  "call.profile_action_report": "通報する",
  "call.profile_action_report_meta": "モデレーターに報告する",
  "call.profile_sheet_close": "プロフィール操作を閉じる",
  "call.profile_open_actions": "プロフィール操作を開く",
  "call.dm_title": "ダイレクトメッセージ",
  "call.dm_back": "操作に戻る",
  "call.dm_close": "DMを閉じる",
  "call.dm_status_online": "オンライン",
  "call.dm_in_room_with": "同じルームにいるよ",
  "call.dm_private_label": "プライベートチャット",
  "call.dm_private_meta": "2人だけのひみつのチャットだよ",
  "call.dm_input_placeholder": "DMを送る...",
  "call.dm_send": "送信",
  "call.dm_just_now": "今",
  "call.dm_seen_just_now": "既読",
  "call.dm_typing": "{name} が入力中...",
  "call.dm_minimize": "最小化",
  "call.dm_active_indicator": "チャットを開く",
  "call.dm_unread_messages": "未読 {count} 件",
  "call.dm_toast_tap_to_open": "タップして開く",
  "call.dm_reopen_aria": "{name} とのチャットを再開",
  "home.join_denied": "ホストに入室を断られちゃった。",
  "home.error.room_not_found": "そのルームコードは存在しないよ。",
  "home.error.profile_required": "進むにはプロフィールを設定してね。",
  "home.cta.set_up_profile": "プロフィールを設定する",
  "home.profile_trigger_new": "タップして詳細を追加",
  "home.profile_trigger_new_aria": "プロフィールを設定する",
  "home.profile_trigger_edit_aria": "プロフィールを編集する",
  "profile.eyebrow_new": "よろしくね",
  "profile.eyebrow_edit": "あなたのプロフィール",
  "profile.title_new": "自分らしく。",
  "profile.title_edit": "プロフィール編集",
  "profile.subtitle": "相手に自分のことを少しだけ教えてあげよう。",
  "profile.add_photo": "写真を追加",
  "profile.add_photo_soon": "写真は準備中だよ",
  "profile.photo_empty": "タップして写真を追加",
  "profile.photo_ready": "写真OK！",
  "profile.photo_save_first": "写真をアップする前にプロフィールを保存してね",
  "profile.photo_crop_caption": "いい感じに切り取ろう",
  "profile.photo_auto_caption": "ドラッグ＆ズームで調整してね。自動で保存されるよ",
  "profile.photo_upload": "写真をアップロード",
  "profile.photo_replace": "写真を変更",
  "profile.photo_remove": "写真を削除",
  "profile.photo_cancel": "キャンセル",
  "profile.photo_save": "写真を保存",
  "profile.photo_uploading": "アップロード中...",
  "profile.photo_removing": "削除中...",
  "profile.photo_choose_another": "別の写真を選ぶ",
  "profile.photo_drag_hint": "写真をドラッグして円に合わせてね。自動で保存されるよ。",
  "profile.photo_zoom": "ズーム",
  "profile.photo_horizontal": "横方向の切り取り",
  "profile.photo_vertical": "縦方向の切り取り",
  "profile.name_label": "名前",
  "profile.name_placeholder": "なんて呼べばいい？",
  "profile.gender_label": "性別",
  "profile.gender.woman": "女性",
  "profile.gender.man": "男性",
  "profile.gender.unspecified": "言いたくない",
  "profile.bio_label": "自己紹介",
  "profile.bio_optional": "任意",
  "profile.bio_placeholder": "話せる言語や好きなこと、なんでも書いてね...",
  "profile.cta_new": "はじめる",
  "profile.cta_edit": "変更を保存",
  "profile.saving": "保存中...",
  "profile.close": "閉じる",
  "profile.error.save_failed": "プロフィールを保存できなかったよ。もう一度試してね。",
  "profile.error.avatar_invalid_type": "PNG、JPEG、GIF、WebPのどれかを選んでね。",
  "profile.error.avatar_too_large": "5MB以下の画像を選んでね。",
  "profile.error.avatar_too_small": "96x96ピクセル以上の画像を選んでね。",
  "profile.error.avatar_load_failed": "画像を読み込めなかったよ。別のファイルで試してみて。",
  "profile.error.avatar_failed": "写真をアップロードできなかったよ。もう一度試してね。",
  "profile.error.avatar_remove_failed": "写真を削除できなかったよ。もう一度試してね。",
  "effects.title": "エフェクト",
  "effects.soft": "ソフトフォーカス",
  "effects.vignette": "ビネット",
  "effects.face": "顔ぼかし",
  "effects.face_preview_only": "顔ぼかし (プレビューのみ)",
  "effects.face_viewer_side": "顔ぼかし (視聴者側)",
  "effects.face_strength": "顔ぼかしの強さ",
  "effects.grade.off": "オフ",
  "effects.grade.pop": "ポップ",
  "effects.grade.warm": "ウォーム",
  "effects.grade.cool": "クール",
  "effects.grade.bw": "モノクロ",
  "camera.off": "カメラオフ",
  "camera.check": "カメラをチェック",
  "camera.retry": "カメラを再試行",
  "camera.ready": "カメラOK！",
  "camera.idle.title": "カメラをオンにしてね",
  "camera.idle.hint": "準備ができたらブラウザにアクセス許可を求めるね。",
  "camera.idle.button": "カメラをオンにする",
  "camera.status.idle": "準備待ち",
  "camera.status.off": "カメラはオフだよ",
  "camera.status.loading": "カメラのアクセスをリクエスト中...",
  "camera.status.denied": "ブラウザでカメラのアクセスを許可して、もう一度試してね。",
  "camera.status.error": "カメラのプレビューに失敗しちゃった。もう一度試してね。",
  "camera.status.unsupported": "このブラウザはカメラに対応してないみたい。",
  "camera.status.insecure": "カメラを使うにはHTTPSかlocalhostが必要だよ。",
  "camera.status.attach_failed": "カメラのプレビューを開始できなかったよ。もう一度試してね。",
  "camera.guest_name_placeholder": "ゲスト名",
  "camera.flip": "カメラを切り替え",
  "camera.save_name": "保存",
  "camera.edit_name": "名前を編集",
  "mic.on": "マイクをオフにする",
  "mic.off": "マイクをオンにする",
  "video.on": "カメラをオフにする",
  "video.off": "カメラをオンにする",
  "chat.title": "チャット",
  "chat.close": "チャットを閉じる",
  "chat.loading": "読み込み中...",
  "chat.load_earlier": "過去のメッセージを読み込む",
  "chat.empty": "まだメッセージはないよ",
  "chat.send_error": "メッセージを送れなかったよ。もう一度試してね。",
  "chat.input_placeholder": "メッセージを入力...",
  "room.host": "ホスト",
  "app.room_default_title": "ルームを作成",
  "app.chat_connection_rejected": "チャットに接続できなかったよ。リロードしてみてね。",
  "app.copy_failed": "リンクをコピーできなかったよ。手動で選択してコピーしてみて。",
  "app.chat_not_connected": "チャットがまだ繋がってないよ。少し待ってからもう一度試してね。",
  "footer.terms": "利用規約",
  "footer.copyright": "© 2026 Yano.AI"
}
